import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.audits.systemlogs.data = {
      ...state.developer.audits.systemlogs.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.developer.audits.systemlogs.busy = true;
  });

  try {
    params = {
      limit: params.limit || store.state.developer.audits.systemlogs.pagination.limit,
      ...params,
    };

    const response = await Http.get(`/app/audits/system-logs`, { params });

    store.setState((state) => {
      state.developer.audits.systemlogs = {
        ...state.developer.audits.systemlogs,
        busy: false,
        data: response.data,
        pagination: {
          ...state.developer.audits.systemlogs.pagination,
          ...response.meta.pagination,
          limit: params.limit || state.developer.audits.systemlogs.pagination.limit,
        },
        filters: {
          ...state.developer.audits.systemlogs.filters,
          ...params,
          to: params.to,
          from: params.from,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.audits.systemlogs.busy = false;
      state.developer.audits.systemlogs.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.audits.systemlogs = { ...initialState };
  });
};

const SystemLogListStore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
  },
};

export default SystemLogListStore;
